import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../services/api";
import "./DepartmentsPage.css"; // Add CSS for styling

const DepartmentsPage = () => {
    const { id: businessId } = useParams();
    const [departments, setDepartments] = useState([]);
    const [newDepartmentName, setNewDepartmentName] = useState("");
    const [newDepartmentShort, setNewDepartmentShort] = useState("");
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/business/${businessId}/departments`);
                setDepartments(response.data);
            } catch (error) {
                console.error("Error fetching departments:", error);
                setError("Failed to load departments.");
            } finally {
                setLoading(false);
            }
        };

        fetchDepartments();
    }, [businessId]);

    const handleAddDepartment = async (e) => {
        e.preventDefault();

        if (!newDepartmentName || !newDepartmentShort) {
            setError("Please enter department details.");
            return;
        }

        try {
            const response = await api.post(`/business/${businessId}/departments`, {
                department_name: newDepartmentName,
                department_short: newDepartmentShort
            });

            setDepartments(prev => [
                ...prev, 
                { 
                    id: response.data.id, 
                    department_name: newDepartmentName, 
                    department_short: newDepartmentShort 
                }
            ]);

            setNewDepartmentName("");
            setNewDepartmentShort("");
            setError(null);
        } catch (error) {
            console.error("Error adding department:", error);
            setError("Failed to add department.");
        }
    };

    return (
        <div className="departments-container">
            <h3>Departments</h3>

            {/* Add Department Form */}
            <div className="add-department-box">
                {error && <p className="error">{error}</p>}
                <form
                className="department-form"
                onSubmit={handleAddDepartment}>
                    <input 
                        type="text" 
                        placeholder="Department Name" 
                        value={newDepartmentName} 
                        onChange={(e) => setNewDepartmentName(e.target.value)} 
                        required 
                    />
                    <input 
                        type="text" 
                        placeholder="Short Form (e.g., HR, IT)" 
                        value={newDepartmentShort} 
                        onChange={(e) => setNewDepartmentShort(e.target.value)} 
                        required 
                    />
                    <button type="submit">Add Department</button>
                </form>
            </div>

            {/* List of Departments */}
            <div className="departments-list">
                <h4>Existing Departments</h4>
                {loading ? (
                    <p>Loading...</p>
                ) : departments.length === 0 ? (
                    <p>No departments found.</p>
                ) : (
                    <ul>
                        {departments.map((dept) => (
                            <li key={dept.id}>
                                {dept.department_name} ({dept.department_short})
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default DepartmentsPage;
